import type { ParcelDetail } from '../types/filters';

interface ParcelPopupProps {
  parcel: ParcelDetail;
  onClose: () => void;
}

export function ParcelPopup({ parcel, onClose }: ParcelPopupProps) {
  return (
    <div className="parcel-popup">
      <div className="parcel-popup-header">
        <h3>Działka {parcel.parcel_number}</h3>
        <button onClick={onClose} className="close-button" aria-label="Zamknij">
          ×
        </button>
      </div>

      <div className="parcel-popup-content">
        <dl>
          {parcel.district && (
            <>
              <dt>Obręb</dt>
              <dd>{parcel.district}</dd>
            </>
          )}

          {parcel.commune && (
            <>
              <dt>Gmina</dt>
              <dd>{parcel.commune}</dd>
            </>
          )}

          {parcel.area_m2 && (
            <>
              <dt>Powierzchnia</dt>
              <dd>{parcel.area_m2.toLocaleString('pl-PL')} m²</dd>
            </>
          )}

          {parcel.tender_type && (
            <>
              <dt>Typ</dt>
              <dd className={`tender-type tender-type-${parcel.tender_type}`}>
                {parcel.tender_type === 'sale' && 'Sprzedaż'}
                {parcel.tender_type === 'lease' && 'Dzierżawa'}
                {parcel.tender_type === 'auction' && 'Przetarg'}
                {parcel.tender_type === 'other' && 'Inne'}
              </dd>
            </>
          )}

          {parcel.price !== null && (
            <>
              <dt>Cena</dt>
              <dd>{parcel.price.toLocaleString('pl-PL')} zł</dd>
            </>
          )}

          {parcel.tender_date && (
            <>
              <dt>Data przetargu</dt>
              <dd>{new Date(parcel.tender_date).toLocaleDateString('pl-PL')}</dd>
            </>
          )}

          {parcel.source_name && (
            <>
              <dt>Źródło</dt>
              <dd>{parcel.source_name}</dd>
            </>
          )}
        </dl>

        {parcel.source_url && (
          <a
            href={parcel.source_url}
            target="_blank"
            rel="noopener noreferrer"
            className="source-link"
          >
            Zobacz ogłoszenie →
          </a>
        )}
      </div>
    </div>
  );
}
